import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @file Highway default renderer that handle DOM stuffs.
 * @author Anthony Du Pont <bulldog@dogstudio.co>
 */
var Renderer =
/*#__PURE__*/
function () {
  /**
   * @arg {object} properties — Set of properties (slug, page, view,...)
   * @constructor
   */
  function Renderer(properties) {
    _classCallCheck(this, Renderer);

    // We get the view.
    this.wrap = document.querySelector('[data-router-wrapper]'); // We save properties of the renderer

    this.properties = properties; // We get our transition we will use later to show/hide our view.

    this.Transition = properties.transition ? new properties.transition["class"](this.wrap, properties.transition.name) : null;
  }
  /**
   * Renderer initialization.
   */


  _createClass(Renderer, [{
    key: "setup",
    value: function setup() {
      // These both methods have to be called at least once on first load.
      this.onEnter && this.onEnter();
      this.onEnterCompleted && this.onEnterCompleted();
    }
    /**
     * Add view in DOM, then remove previous view
     */

  }, {
    key: "add",
    value: function add() {
      // We setup the DOM for our [data-router-view]
      this.wrap.insertAdjacentHTML('beforeend', this.properties.view.outerHTML);
    }
    /**
     * Update document informations
     */

  }, {
    key: "update",
    value: function update() {
      // Now we update all the informations in the DOM we need!
      // We update the title
      document.title = this.properties.page.title;
    }
    /**
     * Add the view in DOM and play an `in` transition if one is defined.
     *
     * @param {object} datas - Set of datas
     * @return {object} Promise
     */

  }, {
    key: "show",
    value: function show(datas) {
      var _this = this;

      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(resolve) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  // Update DOM.
                  _this.update(); // The `onEnter` method if set is called everytime the view is appended
                  // to the DOM. This let you do some crazy stuffs at this right moment.


                  _this.onEnter && _this.onEnter(); // The transition is set in your custom renderer with a getter called
                  // `transition` that should return the transition object you want to
                  // apply to you view. We call the `in` step of this one right now!

                  _context.t0 = _this.Transition;

                  if (!_context.t0) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return _this.Transition.show(datas);

                case 6:
                  // The `onEnterCompleted` method if set in your custom renderer is called
                  // everytime a transition is over if set. Otherwise it's called right after
                  // the `onEnter` method.
                  _this.onEnterCompleted && _this.onEnterCompleted(); // We resolve the Promise.

                  resolve();

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
    /**
     * Play an `out` transition if one is defined and remove the view from DOM.
     *
     * @param {object} datas - Set of datas
     * @return {object} Promise
     */

  }, {
    key: "hide",
    value: function hide(datas) {
      var _this2 = this;

      return new Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // The `onLeave` method if set in your custom renderer is called everytime
                  // before a view will be removed from the DOM. This let you do some stuffs
                  // right before the view isn't available anymore.
                  _this2.onLeave && _this2.onLeave(); // We call the `out` step of your transition right now!

                  _context2.t0 = _this2.Transition;

                  if (!_context2.t0) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return _this2.Transition.hide(datas);

                case 5:
                  // The `onLeaveCompleted` method if set in your custom renderer is called
                  // everytime a view is completely removed from the DOM.
                  _this2.onLeaveCompleted && _this2.onLeaveCompleted(); // Resolve Promise

                  resolve();

                case 7:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);

  return Renderer;
}();

export { Renderer as default };